module.exports = __webpack_public_path__ + "media/courses/curricula/images/access-ended-333a56549cf36453d9bf758d481125c8.svg";